import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { ButtonIcon } from "./ButtonIcon";
import { createStyles } from "./styles";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Button = function Button(_ref) {
  var children = _ref.children,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? "default" : _ref$appearance,
    href = _ref.href,
    download = _ref.download,
    target = _ref.target,
    icon = _ref.icon,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? "left" : _ref$iconPosition,
    iconOverride = _ref.iconOverride,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$stretch = _ref.stretch,
    stretch = _ref$stretch === void 0 ? false : _ref$stretch,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    className = _ref.className,
    testId = _ref["data-testid"],
    ariaLabel = _ref["aria-label"],
    _ref$squared = _ref.squared,
    squared = _ref$squared === void 0 ? false : _ref$squared;
  // @ts-ignore
  if (appearance === "secondary") {
    throw new Error("The secondary appearance has been renamed to default");
  }
  // @ts-ignore
  if (appearance === "success") {
    throw new Error("The success appearance has been removed");
  }
  var styles = React.useMemo(function () {
    return createStyles({
      size: size,
      stretch: stretch,
      appearance: appearance,
      disabled: disabled,
      squared: squared,
      iconOnly: Boolean(icon) && !children
    });
  }, [size, stretch, appearance, disabled, loading, icon]);
  var sharedProps = {
    css: styles,
    disabled: disabled,
    onClick: disabled ? undefined : onClick,
    className: className,
    "data-testid": testId,
    "aria-label": ariaLabel
  };
  if (href) {
    return ___EmotionJSX("a", _extends({
      "data-bpl": true
    }, sharedProps, href ? {
      href: disabled ? undefined : href,
      target: target,
      rel: !!target && target === "_blank" ? "noopener noreferrer" : undefined,
      download: download
    } : {}), ___EmotionJSX(ButtonIcon, {
      icon: icon,
      loading: loading,
      iconOverride: iconOverride,
      position: iconPosition
    }), ___EmotionJSX("span", null, children));
  }
  return ___EmotionJSX("button", _extends({
    "data-bpl": true
  }, sharedProps), ___EmotionJSX(ButtonIcon, {
    icon: icon,
    loading: loading,
    iconOverride: iconOverride,
    position: children ? iconPosition : "center"
  }), ___EmotionJSX("span", null, children));
};